export default __webpack_public_path__ + "static/media/Sandyaid.a74931a2.pdf";